import { StatusCodes } from 'http-status-codes';
import { axiosInstance } from './axiosInstance';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

export const getProductsByBusinessId = async (businessId) => {
  let response;

  try {
    if (businessId) {
      response = await axiosInstance.get(`/business-details/${businessId}/products`);
    } else {
      response = {};
    }

  } catch (err) {
    response = handleErrorResponse(err);
  }
  return response;
};

export const getProductList = async ({
  financeTenure,
  timeInBusiness,
  revenueBracket,
  loanAmount }) => {

  let response;

  try {

    const queryParams = new URLSearchParams();

    if (financeTenure) {
      queryParams.append('financeTenure', financeTenure);
    }

    if (timeInBusiness) {
      queryParams.append('timeInBusiness', timeInBusiness);
    }

    if (revenueBracket) {
      queryParams.append('revenueBracket', revenueBracket);
    }

    if (loanAmount) {
      queryParams.append('loanAmount', loanAmount);
    }

    const apiUrl = `/products?${queryParams.toString()}`;

    response = await axiosInstance.get(apiUrl);

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetProductListError');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};